import { Activity, ISiteActivityApi, SubmissionType } from '@cms-max/medicare-api-sdk'
import { medicareApiClient } from 'clients/medicareApiClient'
import { Event, EventPublisher } from 'pubsub/eventsV2'
import { Logger } from 'utils/logger'
import { CoreEvent } from '.'

export type SiteActivity = CoreEvent

const subscribe = (eventPublisher: EventPublisher) => {
  return eventPublisher.subscribe({
    next: (event: Event) => {
      if (!event.core) {
        return
      }
      const { coreClickData, additionalData, submissionType, ...data } = event.core

      const coreApiEvent = {
        ...data,
        // data is required by the backend and must always be defined, even if empty
        data: {
          ...coreClickData,
          ...additionalData
        }
      }
      // Use the event subscriber so we can spy properly on functions in tests
      if (submissionType && coreApiEvent.activity === Activity.DownstreamServiceResponse) {
        coreEventSubscriber.sendCoreAPIDownstreamEvent(coreApiEvent, submissionType)
      } else {
        coreEventSubscriber.sendCoreAPIEvent(coreApiEvent)
      }
    }
  })
}

const sendCoreAPIEvent = async (event: ISiteActivityApi) => {
  try {
    await medicareApiClient.asyncPostSiteActivityV2(event)
  } catch (error) {
    Logger.log('Error sending siteActivity to CoreAPI')
  }
}

const sendCoreAPIDownstreamEvent = async (event: ISiteActivityApi, submissionType: SubmissionType) => {
  try {
    await medicareApiClient.asyncPostDownstreamEvent(event, submissionType)
  } catch (error) {
    Logger.log('Error sending siteActivity to CoreAPI')
  }
}

export const coreEventSubscriber = {
  subscribe,
  sendCoreAPIEvent,
  sendCoreAPIDownstreamEvent
}
